import { useLayoutEffect, useRef } from 'react'
import { ICurriculumNavList } from '@/features/common/types'
import _ from 'lodash'
import styles from './WithCurriculumLayout.module.scss'
import { useMediaQuery } from '@mantine/hooks'
import { usePathname, useRouter } from 'next/navigation'
interface MenubarNavProps {
  navList: ICurriculumNavList[]
  gotoPage: (href: string) => void
  isActive: (href: string) => boolean
}

const MenubarNav = ({ navList, gotoPage, isActive }: MenubarNavProps) => {
  const scrollRef = useRef<HTMLUListElement>(null)
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const pathname = usePathname()

  useLayoutEffect(() => {
    if (scrollRef.current) {
      const handleScroll = _.debounce(() => {
        const navIndex = navList.findIndex(item => item.id === pathname.split('/')[2])
        const container = scrollRef.current
        if (!container) return
        
        const itemWidth = 60
        const containerWidth = container.clientWidth
        const scrollPosition = (itemWidth * navIndex) - (containerWidth / 2) + (itemWidth / 2)
        
        container.scrollTo({
          left: Math.max(0, scrollPosition),
          behavior: 'smooth',
        })
      }, 100)

      handleScroll()
      return () => handleScroll.cancel()
    }
  }, [scrollRef])

  return (
    <ul
      ref={scrollRef}
      className={`${styles.scrollHidden} sticky top-0 z-10 flex w-full gap-x-5 overflow-x-scroll border-b bg-white px-4 shadow-[2px_6px_15px_-4.042px_rgba(22,52,80,0.10)] lg:relative lg:mt-3 lg:flex lg:flex-col lg:gap-x-2 lg:gap-y-1.5 lg:border-0 lg:p-0 lg:shadow-none`}
    >
      {navList.map(({ id, icon, title, href }) => (
        <li
          key={`curriculum_nav_${title}`}
          onClick={() => gotoPage(href)}
          className={`${
            isActive(id) ? 'border-b-2 border-primary-normal lg:bg-primary-subdued' : ''
          } flex shrink-0 cursor-pointer items-center gap-x-2 overflow-hidden py-3 lg:gap-x-3 lg:rounded-lg lg:border-0 lg:px-3`}
        >
          {!isMobile && (
            <div
              className={`stroke-[0.3px] ${
                isActive(id)
                  ? 'fill-primary-normal stroke-primary-normal text-primary-normal'
                  : 'fill-gray-400 stroke-gray-400 text-label-alternative'
              } w-5`}
            >
              {icon}
            </div>
          )}
          <p
            className={`${
              isActive(id) ? 'text-primary-normal' : 'text-label-alternative'
            } whitespace-nowrap text-base font-semibold`}
          >
            {title}
          </p>
        </li>
      ))}
    </ul>
  )
}

export default MenubarNav
